module.exports = __webpack_public_path__ + "images/a2b368f89af7789e95578210f9e1c5b0-course4.jpg";